import { useEffect } from 'react';
import store from "../../../../store";
import workspace from "../../components/canvas/core/workspace";
import sqftShapeManager from "../../components/canvas/store/sqftShapeManager";

const useUpdateEditedFeatures = () => {

  //modify backsplash, countertops & edges on edit from cart click
  useEffect (() => {
    const state = store.getState();
    const {cartItemEditFeature} = state.cartState;
    const {activeFeature} = state.selectionState;

    if (cartItemEditFeature && activeFeature) {
      if (cartItemEditFeature.partId === activeFeature.partId) {
        const sqftFeaturesByPartId = workspace.getShapesByPartId(activeFeature.partId);
        if (sqftFeaturesByPartId && sqftFeaturesByPartId.length) {
          //include slab shapes
          const sqftFeaturesByFeatureId = workspace.getShapesByFeatureId(sqftFeaturesByPartId[0].featureId);
          for (const sqftFeature of sqftFeaturesByFeatureId) {
            if (sqftFeature.featureId === cartItemEditFeature?.cartFeature.dbFeature?.id) {
              sqftShapeManager.setShapeFeature(sqftFeature.id, activeFeature);
              sqftShapeManager.updateShapesWizardProperties();
            }
          }
        }
      }
    }
  }, []);
};

export default useUpdateEditedFeatures;
